/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useEffect, useState} from 'react'
import {Redirect, Switch, Route, useLocation, useHistory} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {AuthPage, Logout} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import PaymentCallbackPage from '../modules/payment-callback/PaymentCallbackPage'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import {getUserInfo} from '../modules/auth/helpers'
import {getListCategory} from '../utils'
import {apiGetConfigMultiLanguage, useLang} from '../../_metronic/i18n/Metronici18n'
import Cookies from 'js-cookie'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import SignaturePage, { IDataPage } from '../modules/signatureFile/SignatureFilePage'

const Routes: FC = () => {
  const [isAuthorized, setAuthorized] = useState(false)
  const [isSignature, setIsSignature] = useState(false)
  const [paramPageSign, setParamPageSign] = useState<IDataPage>({
    id: '',
    idDetails: '',
    groupDomain: '',
    refId: '',
    type: ''
  })
  let location = useLocation()
  let history = useHistory()
  const dispatch = useDispatch()
  const authState = useSelector((state: RootState) => state.auth)

  const authToken = authState.accessToken
  const lang = useLang()

  const apiGetListCategory = (type: string) => {
    getListCategory(type).then((res: any) => {
      if (res && !res.isError) {
        res.data.map((o: any) => {
          o.name = o.name + ' - ' + o.code
        })
        if (type == 'USER') {
          localStorage.setItem('category', JSON.stringify(res.data))
        }
        if (type == 'USERAPPROVE') {
          localStorage.setItem('user-approve', JSON.stringify(res.data))
        }
      }
    })
  }

  const redirectUrl = (type: any, id: any, productCode?: any, sign?: any) => {
    if (type == 'quotation') {
      let pathname = ''
      switch (productCode) {
        case 'P_I':
          pathname = '/crafted/insurance/person-insurance-coop'
          break
        default:
          pathname = '/crafted/insurance/person-insurance-coop'
          break
      }
      history.push({
        pathname: pathname,
        state: {
          form: 2,
          idContract: id,
          sign: sign
        },
      })
    }
    if (type == 'approval') {
      history.push({
        pathname: '/crafted/report',
        state: {
          form: 1,
          idContract: id,
        },
      })
    }
  }

  useEffect(() => {
    if (authToken) {
      const userId = authState.userId
      if (userId) {
        apiGetListCategory('USER')
        apiGetListCategory('USERAPPROVE')
        apiGetConfigMultiLanguage(lang.toLocaleUpperCase(), '2')
        setTimeout(() => {
          setAuthorized(true)
        }, 300)
      }
    } else {
      const checkLogin = getUserInfo()
      if (checkLogin) {
        setAuthorized(true)
        history.push(location.pathname)
      }
    }
  }, [authToken])

  useEffect(() => {
    if (location.pathname.startsWith('/e_signature')) {
      setAuthorized(true)
      setIsSignature(true)
      const query = new URLSearchParams(location.search)
      if (
        query.get('id') &&
        query.get('idDetails') &&
        query.get('type') &&
        query.get('refId') &&
        query.get('groupDomain')
      ) {
        setParamPageSign({
          id: query.get('id'),
          idDetails: query.get('idDetails'),
          type: query.get('type'),
          refId: query.get('refId'),
          groupDomain: query.get('groupDomain'),
        })
      }
      return
    }
    if (
      location.pathname.startsWith('/auth/registration') ||
      location.pathname == '/auth/change-password'
    ) {
      setAuthorized(false)
    } else {
      if (location.pathname.startsWith('/auth/login') && Cookies.get('UserInfo')) {
        const query = new URLSearchParams(location.search)
        if (query.get('type') && query.get('id')) {
          redirectUrl(query.get('type'), query.get('id'), query.get('product'), query.get('sign'))
        }
      }
      if (authToken && !isAuthorized) setAuthorized(true)
      dispatch(filter.actions.cleanFilterInfo('FilterPersonInsurance'))
      dispatch(filter.actions.cleanFilterInfo('FilterCustomer'))
      dispatch(filter.actions.cleanFilterInfo('FilterPayment'))
      dispatch(filter.actions.cleanFilterInfo('FilterRenew'))
      // if (location.pathname !== '/' || !location.pathname.includes('/auth')) {
      //   let test = functionCheckPermission(menu, location.pathname)
      //   if(!test) history.push('/error/404')
      // }
    }
  }, [location.pathname])

  useEffect(() => {
    if (isAuthorized) {
      const query = new URLSearchParams(location.search)
      if (query.get('type') && query.get('id')) {
        redirectUrl(query.get('type'), query.get('id'))
      }
    }
  }, [isAuthorized])

  return (
    <Switch>
      {isSignature && (
        <Route>
          <SignaturePage dataPage={paramPageSign} />
        </Route>
      )}
      {!isAuthorized ? (
        <Route>
          <AuthPage />
        </Route>
      ) : (
        <Redirect from='/auth' to='/dashboard' />
      )}
      <Route path='/payment' component={PaymentCallbackPage} />
      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />

      {!isAuthorized ? (
        <Redirect to='/auth/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
      <MasterLayout>
        <PrivateRoutes />
      </MasterLayout>
    </Switch>
  )
}

export {Routes}
